export default {
  beforeRouteLeave(to, from, next) {
    this.disablePageGA()
    next()
  },
  data() {
    return {
      GA_ID: this.defaultValue?.params?.seo || [],
    }
  },
  created() {
    if(this.GA_ID.length) {
      this.GA_ID.forEach((item) => {
        if (['Google Analytics', 'Google Ads'].includes(item.type)) {
          if (window[`ga-disable-${ item.code }`] !== undefined) {
            this.disablePageGA(false)
          }
        }
      })
      this.initPageGA()
    }
  },
  methods: {
    initPageGA(event = 'pageview_by_zerone') {
      this.GA_ID.forEach((item) => {
        if (item.type === 'Google Analytics') {
          this.$gtag.query('config', item.code);
          this.$gtag.query('event', event, { 'send_to': item.code })
        } else if (item.type === 'Google Ads') {
          this.$gtag.query('config', item.code);
          // console.log(`${item.code}${!!item.label ? `/${item.label}` : ''}`)
          this.$gtag.query('event', 'conversion', { 'send_to': `${item.code}${!!item.label ? `/${item.label}` : ''}` })
        }
      })
    },
    disablePageGA(disabled = true) {
      if (!this.GA_ID.length) return

      this.GA_ID.forEach((item) => {
        if (['Google Analytics', 'Google Ads'].includes(item.type)) {
          window[`ga-disable-${ item.code }`] = disabled
        }
      })
    },
  }
};
